<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <h4 style="padding-bottom: 20px">Ваша картина</h4>
            <div style="padding-bottom: 20px; aspect-ratio: 100/35;">
                <transition name="slide-fade">
                    <div v-if="show_data" class="row justify-content-evenly">
                        <div class="col-lg-4 col-md-5 col-6">
                            <img :src="img_final" style="width: 100%; border: solid 4px lightgray">
                        </div>
                        <div class="col-lg-4 col-md-5 col-6">
                            <span>Ваша картина почти готова. Скачайте pdf инструкцию и начинайте творить.</span><br><br><br>
                            <a :href="path_pdf" target="_blank">Открыть Инструкцию</a><br><br><br>
                            <a :href="path_pdf" download="PIXSMART">Скачать Инструкцию</a><br><br><br>
                            <span>Ниже есть несколько советов, они помогут вам избежать некоторых ошибок.</span>
                        </div>
                    </div>
                </transition>
            </div>

            <div id="pl" v-if="show_spinner">
                <grid-loader class="sp" :loading="true" color="blue"></grid-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import GridLoader from 'vue-spinner/src/GridLoader.vue';

    export default {
        name: "PdfN",
        components: {
            GridLoader
        },
        data() {
            return {
                qr_code: null,
                show_spinner: false,
                img_final: null,
                show_data: false,
                path_pdf: '',
            }
        },
        methods: {
            async load_data() {
                try {
                    this.qr_code = this.$route.params.qr_code;
                    this.show_spinner = true;

                    const response = await
                        this.$axios.post('/instruction_data',
                            {
                                qr_code: this.qr_code,
                            });

                    let res_check = response.data.res_check;
                    if (res_check === 'pdf') {
                        this.path_pdf = response.data.path_pdf;
                        this.img_final = `data:image/jpeg;base64,${response.data.img_final}`;
                    } else {
                        this.$router.push('/qr_code');
                    }

                    this.show_spinner = false;
                    this.show_data = true;
                } catch (e) {
                    console.log(e);
                    this.show_spinner = false;
                }
            },
        },
        created() {
            this.load_data();
        }
    }
</script>

<style scoped>

</style>